
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upgrade-browser",
      function () {
        return require("private-next-pages/upgrade-browser.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upgrade-browser"])
      });
    }
  